module.exports = __webpack_public_path__ + "static/img/core_step.55211b9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/core_step.png
// module id = iqsr
// module chunks = 0